/**
 * @descripttion: 时间戳格式化为日期时间格式
 * @Author: juanjuanhui
 * @Date: 2021-06-23 20:54:20
 * @param {Number} date 13位时间戳
 * @param {String} fmt 格式模板，如yyyy-MM-dd hh:mm:ss或yyyy-MM-dd hh:mm或yyyy-MM-dd
 * @return {String} fmt 如2021-06-23 18:49:41
 */
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      )
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}
